import { __exports as types } from "../../../../../../../_virtual/types.js";
var hasRequiredTypes;
function requireTypes() {
  if (hasRequiredTypes) return types;
  hasRequiredTypes = 1;
  types.__esModule = true;
  types.UNIVERSAL = types.TAG = types.STRING = types.SELECTOR = types.ROOT = types.PSEUDO = types.NESTING = types.ID = types.COMMENT = types.COMBINATOR = types.CLASS = types.ATTRIBUTE = void 0;
  var TAG = "tag";
  types.TAG = TAG;
  var STRING = "string";
  types.STRING = STRING;
  var SELECTOR = "selector";
  types.SELECTOR = SELECTOR;
  var ROOT = "root";
  types.ROOT = ROOT;
  var PSEUDO = "pseudo";
  types.PSEUDO = PSEUDO;
  var NESTING = "nesting";
  types.NESTING = NESTING;
  var ID = "id";
  types.ID = ID;
  var COMMENT = "comment";
  types.COMMENT = COMMENT;
  var COMBINATOR = "combinator";
  types.COMBINATOR = COMBINATOR;
  var CLASS = "class";
  types.CLASS = CLASS;
  var ATTRIBUTE = "attribute";
  types.ATTRIBUTE = ATTRIBUTE;
  var UNIVERSAL = "universal";
  types.UNIVERSAL = UNIVERSAL;
  return types;
}
export {
  requireTypes as __require
};
//# sourceMappingURL=types.js.map
